// Archivio Programmi TV (archive-programmi_tv.php): due componenti
// indipendenti, ciascuno no-op se il proprio markup non e' in pagina.
//
// 1) initArchivioProgrammiTvGridSection(): "Carica altri programmi"/"Mostra
//    meno" (assets/js/load-more-grid.js) sulla griglia principale - tutte le
//    card sono gia' nel markup server-side (pre_get_posts in inc/cpt.php,
//    posts_per_page -1), niente REST: stesso identico principio di
//    initGalleryGrid() in assets/js/gallery.js/initPodcastVideoSection() in
//    assets/js/podcast-video.js, qui senza filtro/ricerca (non richiesti per
//    questo archivio).
//
// 2) initArchivioProgrammiTvFeaturedSection(): carosello a slide singola
//    della sezione "In evidenza"
//    (template-parts/archivio-programmi-tv/featured.php), stessa identica
//    implementazione "vanilla" (nessuna libreria) di
//    initArchivioImpegnoSocialeFeaturedSection() in
//    assets/js/archivio-impegno-sociale.js.
//
// La modale "Scopri di più" di card/slide (template-parts/partials/links-modal.php)
// e' gestita a parte da assets/js/links-modal.js, condivisa con le card
// raggruppate dell'archivio Rassegna Stampa.
import { createLoadMoreGrid } from "./load-more-grid";

const INITIAL_COUNT = 9;
const LOAD_INCREMENT = 9;

function initArchivioProgrammiTvGridSection(section) {
    const grid = section.querySelector("[data-programmi-tv-grid]");

    if (!grid) {
        return;
    }

    const items = Array.from(grid.querySelectorAll("[data-programmi-tv-item]"));
    const loadMoreWrap = section.querySelector("[data-programmi-tv-load-more-wrap]");
    const loadMoreButton = section.querySelector("[data-programmi-tv-load-more]");
    const showLessButton = section.querySelector("[data-programmi-tv-show-less]");
    const shownCountLabel = section.querySelector("[data-programmi-tv-shown-count]");

    const loadMoreGrid = createLoadMoreGrid({
        getItems: () => items,
        initialCount: INITIAL_COUNT,
        loadIncrement: LOAD_INCREMENT,
        loadMoreWrap,
        loadMoreButton,
        showLessButton,
        onRender({ shown, total }) {
            if (shownCountLabel) {
                shownCountLabel.textContent = total > INITIAL_COUNT ? `Mostrati ${shown} di ${total} programmi` : "";
            }
        },
    });

    loadMoreGrid.render();
}

function initArchivioProgrammiTvFeaturedSection(section) {
    const track = section.querySelector("[data-programmi-tv-featured-track]");
    const slides = Array.from(section.querySelectorAll("[data-programmi-tv-featured-slide]"));

    if (!track || slides.length < 2) {
        return;
    }

    const prevButton = section.querySelector("[data-programmi-tv-featured-prev]");
    const nextButton = section.querySelector("[data-programmi-tv-featured-next]");
    const dots = Array.from(section.querySelectorAll("[data-programmi-tv-featured-dot]"));

    let index = 0;

    function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;

        dots.forEach((dot, dotIndex) => {
            dot.classList.toggle("is-active", dotIndex === index);
        });
    }

    if (prevButton) {
        prevButton.addEventListener("click", () => goTo(index - 1));
    }

    if (nextButton) {
        nextButton.addEventListener("click", () => goTo(index + 1));
    }

    dots.forEach((dot) => {
        dot.addEventListener("click", () => {
            const dotIndex = parseInt(dot.dataset.programmiTvFeaturedIndex, 10) || 0;
            goTo(dotIndex);
        });
    });

    let touchStartX = 0;

    track.addEventListener(
        "touchstart",
        (event) => {
            touchStartX = event.touches[0].clientX;
        },
        { passive: true }
    );

    track.addEventListener(
        "touchend",
        (event) => {
            const delta = event.changedTouches[0].clientX - touchStartX;

            if (Math.abs(delta) < 40) {
                return;
            }

            goTo(delta < 0 ? index + 1 : index - 1);
        },
        { passive: true }
    );

    goTo(0);
}

export function initArchivioProgrammiTv() {
    document.querySelectorAll("[data-archivio-programmi-tv]").forEach(initArchivioProgrammiTvGridSection);
    document.querySelectorAll("[data-programmi-tv-featured]").forEach(initArchivioProgrammiTvFeaturedSection);
}
